import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { device } from '../../providers/theme';

const Container = styled.div`
  position: ${props => (props.isOpen ? 'fixed' : 'absolute')};
  top: 22px;
  right: 22px;
  z-index: 2;
  display: none;
  @media ${device.tablet} {
    display: block;
  }
`;

const Icon = styled.div`
    width: 35px;
    height: 30px;
    margin: 0;
    position: relative;
    cursor: pointer;
    display: flex;
    float: right;

    @media ${device.mobile} {
      width: 30px;
      height: 25px;
    }

    span {
      background-color: ${props => (props.isOpen ? '#444' : '#fff')};
      position: absolute;
      border-radius: 2px;
      transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
      width: 100%;
      height: 3px;

      &:nth-child(1) {
        top: 0px;
        left: 0px;
      }

      &:nth-child(2) {
        top: 13px;
        left: 0px;
        @media ${device.mobile} {
          top: 11px;
        }
      }

      &:nth-child(3) {
        bottom: 0px;
        left: 0px;
      }
    }
  }

  &.open span:nth-child(1) {
    top: 13px;
  }
  &.open span:nth-child(3) {
    top: 13px;
  }
}
`;

const Dropdown = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100vw;
  color: #444;
  left: ${props => (props.isOpen ? '0' : '-100vw')};
  transition: left 0.2s ease-in;
  background: #fff;
  padding: 32px;

  @media ${device.mobile} {
    padding: 12px 32px;
  }
`;

const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

const LI = styled.li`
  padding: 8px;
  a {
    padding: 8px 12px;
    font-size: 1.5rem;
    @media ${device.mobile} {
      height: 24px;
    }
  }

  a.active {
    box-shadow: none;
    border-bottom: 1px solid #fff;
  }
`;

function MobileMenu({ pages }) {
  const [navOpen, setOpen] = useState(false);

  return (
    <>
      <Container isOpen={navOpen}>
        <Icon
          isOpen={navOpen}
          className={navOpen ? 'Menu__Icon open' : 'Menu__Icon'}
          onClick={() => setOpen(!navOpen)}
          role="presentation"
        >
          <span />
          <span />
          <span />
        </Icon>
      </Container>
      <Dropdown isOpen={navOpen}>
        <UL isOpen={navOpen}>
          <LI>
            <Link activeClassName="active" to="/">
              Forside
            </Link>
          </LI>
          {pages.map(wine => (
            <LI key={wine.id}>
              <Link activeClassName="active" to={`${wine.url}`}>
                {wine.name}
              </Link>
            </LI>
          ))}
        </UL>
      </Dropdown>
    </>
  );
}

export default MobileMenu;
